/** @format */

import {Routes, Route} from 'react-router-dom';

import {ROUTES} from 'constants/ROUTES';

import PrivateRoute from 'components/PrivateRoute';

import FullReport from './components/FullReport';

const AiReports = () => {
  return (
    <Routes>
      <Route
        path={ROUTES.AI_REPORTS_SHOW}
        element={
          <PrivateRoute>
            <FullReport />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export default AiReports;
